export enum CookieType {
    Necessary,
    Functional,
    Performance,
    Marketing
}
